import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Public PF
import enPublicPF from './locales/english/PublicPF_en.json';
import hiPublicPF from './locales/hindi/PublicPF_hi.json';
import gujPublicPF from "./locales/gujarati/PublicPF_gu.json";
import kanPublicPF from "./locales/kannada/PublicPF_kn.json";
import malPublicPF from "./locales/malayalam/PublicPF_ml.json";
import marPublicPF from "./locales/marathi/PublicPF_mr.json";
import oddPublicPF from "./locales/odia/PublicPF_or.json";
import panPublicPF from "./locales/punjabi/PublicPF_pa.json";
import tamPublicPF from "./locales/tamil/PublicPF_ta.json";
import telPublicPF from "./locales/telegu/PublicPF_te.json";
import benPublicPF from "./locales/bengali/PublicPF_bn.json"

// Employee PF
import enEmployeePF from './locales/english/EmployeePF_en.json';
import hiEmployeePF from './locales/hindi/EmployeePF_hi.json';
import gujEmployeePF from "./locales/gujarati/EmployeePF_gu.json";
import kanEmployeePF from "./locales/kannada/EmployeePF_kn.json";
import malEmployeePF from "./locales/malayalam/EmployeePF_ml.json";
import marEmployeePF from "./locales/marathi/EmployeePF_mr.json";
import oddEmployeePF from "./locales/odia/EmployeePF_or.json";
import panEmployeePF from "./locales/punjabi/EmployeePF_pa.json";
import tamEmployeePF from "./locales/tamil/EmployeePF_ta.json";
import telEmployeePF from "./locales/telegu/EmployeePF_te.json";
import benEmployeePF from "./locales/bengali/EmployeePF_bn.json"

// Senior CS
import enSeniorCS from './locales/english/SeniorCS_en.json';
import hiSeniorCS from './locales/hindi/SeniorCS_hi.json';
import gujSeniorCS from "./locales/gujarati/SeniorCS_gu.json"
import kanSeniorCS from "./locales/kannada/SeniorCS_kn.json"
import malSeniorCS from "./locales/malayalam/SeniorCS_ml.json"
import marSeniorCS from "./locales/marathi/SeniorCS_mr.json"
import oddSeniorCS from "./locales/odia/SeniorCS_or.json"
import panSeniorCS from "./locales/punjabi/SeniorCS_pa.json"
import tamSeniorCS from "./locales/tamil/SeniorCS_ta.json"
import telSeniorCS from "./locales/telegu/SeniorCS_te.json"
import benSeniorCS from "./locales/bengali/SeniorCS_bn.json"

// NationalPS

import enNationalPS from './locales/english/NationalPS_en.json'
import hiNationalPS from './locales/hindi/NationalPS_hi.json'
import gujNationalPS from './locales/gujarati/NationalPS_gu.json'
import kanNationalPS from './locales/kannada/NationalPS_kn.json'
import malNationalPS from './locales/malayalam/NationalPS_ml.json'
import marNationalPS from './locales/marathi/NationalPS_mr.json'
import oddNationalPS from './locales/odia/NationalPS_or.json'
import panNationalPS from './locales/punjabi/NationalPS_pa.json'
import tamNationalPS from './locales/tamil/NationalPS_ta.json'
import telNationalPS from './locales/telegu/NationalPS_te.json'
import benNationalPS from './locales/bengali/NationalPS_bn.json'


// NationalSC

import enNationalSC from "./locales/english/NationalSC_en.json"
import hiNationalSC from "./locales/hindi/NationalSC_hi.json"
import gujNationalSC from "./locales/gujarati/NationalSC_gu.json"
import kanNationalSC from "./locales/kannada/NationalSC_kn.json"
import malNationalSC from "./locales/malayalam/NationalSC_ml.json"
import marNationalSC from "./locales/marathi/NationalSC_mr.json"
import oddNationalSC from "./locales/odia/NationalSC_or.json"
import panNationalSC from "./locales/punjabi/NationalSC_pa.json"
import tamNationalSC from "./locales/tamil/NationalSC_ta.json"
import telNationalSC from "./locales/telegu/NationalSC_te.json"
import benNationalSC from "./locales/bengali/NationalSC_bn.json"

//PMVAYA
import enPMVaya from "./locales/english/PMVaya_en.json"
import hinPMVaya from "./locales/hindi/PMVaya_hi.json"
import gujPMVaya from "./locales/gujarati/PMVaya_gu.json"
import kanPMVaya from "./locales/kannada/PMVaya_kn.json"
import malPMVaya from "./locales/malayalam/PMVaya_ml.json"
import marPMVaya from "./locales/marathi/PMVaya_mr.json"
import oddPMVaya from "./locales/odia/PMVaya_or.json"
import panPMVaya from "./locales/punjabi/PMVaya_pa.json"
import tamPMVaya from "./locales/tamil/PMVaya_ta.json"
import telPMVaya from "./locales/telegu/PMVaya_te.json"
import benPMVaya from "./locales/bengali/PMVaya_bn.json"


// POST OFFICE
import enPostOffice from "./locales/english/PostOfficeSS_en.json"
import hinPostOffice from "./locales/hindi/PostOfficeSS_hi.json"
import gujPostOffice from "./locales/gujarati/PostOfficeSS_gu.json"
import kanPostOffice from "./locales/kannada/PostOfficeSS_kn.json"
import malPostOffice from "./locales/malayalam/PostOfficeSS_ml.json"
import marPostOffice from "./locales/marathi/PostOfficeSS_mr.json"
import oddPostOffice from "./locales/odia/PostOfficeSS_or.json"
import panPostOffice from "./locales/punjabi/PostOfficeSS_pa.json"
import tamPostOffice from "./locales/tamil/PostOfficeSS_ta.json"
import telPostOffice from "./locales/telegu/PostOfficeSS_te.json"
import benPostOffice from "./locales/bengali/PostOfficeSS_bn.json"


// PM Jandhan

import enPMJanDhan from "./locales/english/PMJanDhan_en.json"
import hinPMJanDhan from "./locales/hindi/PMJanDhan_hi.json"
import gujPMJanDhan from "./locales/gujarati/PMJanDhan_gu.json"
import kanPMJanDhan from "./locales/kannada/PMJanDhan_kn.json"
import malPMJanDhan from "./locales/malayalam/PMJanDhan_ml.json"
import marPMJanDhan from "./locales/marathi/PMJanDhan_mr.json"
import oddPMJanDhan from "./locales/odia/PMJanDhan_or.json"
import panPMJanDhan from "./locales/punjabi/PMJanDhan_pa.json"
import tamPMJanDhan from "./locales/tamil/PMJanDhan_ta.json"
import telPMJanDhan from "./locales/telegu/PMJanDhan_te.json"
import benPMJanDhan from "./locales/bengali/PMJanDhan_bn.json"

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
        PublicPF: enPublicPF,
        EmployeePF: enEmployeePF,
        SeniorCS: enSeniorCS,
        NationalPS: enNationalPS,
        NationalSC: enNationalSC,
        PMVaya: enPMVaya,
        PostOfficeSS: enPostOffice,
        PMJanDhan: enPMJanDhan
      },
      hi: {
        PublicPF: hiPublicPF,
        EmployeePF: hiEmployeePF,
        SeniorCS: hiSeniorCS,
        NationalPS: hiNationalPS,
        NationalSC: hiNationalSC,
        PMVaya: hinPMVaya,
        PostOfficeSS: hinPostOffice,
        PMJanDhan: hinPMJanDhan

      },
      gu: {
        PublicPF: gujPublicPF,
        EmployeePF: gujEmployeePF,
        SeniorCS: gujSeniorCS,
        NationalPS: gujNationalPS,
        NationalSC: gujNationalSC,
        PMVaya: gujPMVaya, 
        PostOfficeSS: gujPostOffice,
        PMJanDhan: gujPMJanDhan

      },
      kn: {
        PublicPF: kanPublicPF,
        EmployeePF: kanEmployeePF,
        SeniorCS: kanSeniorCS,
        NationalPS: kanNationalPS,
        NationalSC: kanNationalSC,
        PMVaya: kanPMVaya, 
        PostOfficeSS: kanPostOffice,
        PMJanDhan: kanPMJanDhan

      },
      ml: {
        PublicPF: malPublicPF,
        EmployeePF: malEmployeePF,
        SeniorCS: malSeniorCS,
        NationalPS: malNationalPS,
        NationalSC: malNationalSC,
        PMVaya: malPMVaya, 
        PostOfficeSS: malPostOffice,
        PMJanDhan: malPMJanDhan

      },
      mr: {
        PublicPF: marPublicPF,
        EmployeePF: marEmployeePF,
        SeniorCS: marSeniorCS,
        NationalPS: marNationalPS,
        NationalSC: marNationalSC,
        PMVaya: marPMVaya, 
        PostOfficeSS: marPostOffice,
        PMJanDhan: marPMJanDhan

      },
      or: {
        PublicPF: oddPublicPF,
        EmployeePF: oddEmployeePF,
        SeniorCS: oddSeniorCS,
        NationalPS: oddNationalPS,
        NationalSC: oddNationalSC,
        PMVaya: oddPMVaya, 
        PostOfficeSS: oddPostOffice,
        PMJanDhan: oddPMJanDhan

      },
      pa: {
        PublicPF: panPublicPF,
        EmployeePF: panEmployeePF,
        SeniorCS: panSeniorCS,
        NationalPS: panNationalPS,
        NationalSC: panNationalSC,
        PMVaya: panPMVaya, 
        PostOfficeSS: panPostOffice,
        PMJanDhan: panPMJanDhan

      },
      ta: {
        PublicPF: tamPublicPF,
        EmployeePF: tamEmployeePF,
        SeniorCS: tamSeniorCS,
        NationalPS: tamNationalPS,
        NationalSC: tamNationalSC,
        PMVaya: tamPMVaya, 
        PostOfficeSS: tamPostOffice,
        PMJanDhan: tamPMJanDhan

      },
      te: {
        PublicPF: telPublicPF,
        EmployeePF: telEmployeePF,
        SeniorCS: telSeniorCS,
        NationalPS: telNationalPS,
        NationalSC: telNationalSC,
        PMVaya: telPMVaya, 
        PostOfficeSS: telPostOffice,
        PMJanDhan: telPMJanDhan

      },
      ben: {
        PublicPF: benPublicPF,
        EmployeePF: benEmployeePF,
        SeniorCS: benSeniorCS,
        NationalPS: benNationalPS,
        NationalSC: benNationalSC,
        PMVaya: benPMVaya, 
        PostOfficeSS: benPostOffice,
        PMJanDhan: benPMJanDhan
      }
    },
    defaultNS: 'PublicPF',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18next;
